


























































import { Vue, Component } from "vue-property-decorator";
import { vxm } from "@/store";
import SignInDialog from "@/components/sign-in-dialog.vue";
import imagePlaceholder from "@/components/img-placeholder.vue";

@Component({
  components: {
    "sign-in-dialog": SignInDialog,
    "img-placeholder": imagePlaceholder
  }
})
export default class ResultsNavigationDrawer extends Vue {
  /*
  data() {
    return {
      items: [
        { title: "Standings", icon: "mdi-table" },
        { title: "Answers", icon: "mdi-format-list-checks" },
        { title: "Photowall", icon: "mdi-image-album" },
        { title: "Map", icon: "mdi-map-marker" },
        { title: "Chat", icon: "mdi-forum" },
      ],
      socials: [
        {
          title: "Facebook",
          icon: "mdi-facebook",
          color: "#4267B2",
          link: "https://www.facebook.com/sharer/sharer.php?u=",
        },
        {
          title: "LinkedIn",
          icon: "mdi-linkedin",
          color: "#2867b2",
          link: "https://www.linkedin.com/sharing/share-offsite/?url=",
        },
        {
          title: "Twitter",
          icon: "mdi-twitter",
          color: "#1DA1F2",
          link: "https://twitter.com/home?status=",
        },
      ],
      right: null,
    };
  }
  */
  signInDialog = false;
  socials = [
    {
      title: "Facebook",
      icon: "mdi-facebook",
      color: "#4267B2",
      link: "https://www.facebook.com/sharer/sharer.php?u="
    },
    {
      title: "LinkedIn",
      icon: "mdi-linkedin",
      color: "#2867b2",
      link: "https://www.linkedin.com/sharing/share-offsite/?url="
    },
    {
      title: "Twitter",
      icon: "mdi-twitter",
      color: "#1DA1F2",
      link: "https://twitter.com/home?status="
    }
  ];

  get items() {
    const items = [];
    if (vxm.results.game.publicResults.includes("statistics") || vxm.results.isInstructor) {
      items.push({ title: "Standings", icon: "mdi-table" });
    }
    if (vxm.results.game.publicResults.includes("answers") || vxm.results.isInstructor) {
      items.push({ title: "Answers", icon: "mdi-format-list-checks" });
    }
    if (vxm.results.game.publicResults.includes("photos") || vxm.results.isInstructor) {
      items.push({ title: "Photowall", icon: "mdi-image-album" });
    }
    if (vxm.results.game.publicResults.includes("map") || vxm.results.isInstructor) {
      items.push({ title: "Map", icon: "mdi-map-marker" });
    }
    if (vxm.results.game.publicResults.includes("chat") || vxm.results.isInstructor) {
      items.push({ title: "Chat", icon: "mdi-forum" });
    }
    return items;
  }

  get drawer() {
    return vxm.app.drawer;
  }

  set drawer(value) {
    vxm.app.drawer = value;
  }

  get logoUrl() {
    return vxm.results.game.logoUrl;
  }

  get eventId() {
    return vxm.results.eventId;
  }

  get url() {
    return `https://${window.location.hostname}${this.$route.fullPath}`;
  }

  get user() {
    return vxm.auth.user;
  }

  signOut() {
    vxm.auth.signOut();
  }
}
